import {
  CreateGfFigmaTemplateDataDto,
  UpdateGfFigmaTemplateDataDto,
  GfFigmaTemplateTag,
  GfImage,
  GfFlyerItemCategory,
  GfStore,
  GfFigmaTemplateFile,
} from "@swagger/typescript-fetch-goflyer";

export interface FigmaTemplateFormState {
  name: string;
  figmaTemplateTag?: GfFigmaTemplateTag;
  image?: GfImage;
  numberOfPages: number | "";
  category: GfFlyerItemCategory[];
  type:
    | CreateGfFigmaTemplateDataDto.TypeEnum
    | UpdateGfFigmaTemplateDataDto.TypeEnum
    | "";
  stores: GfStore[];
  figmaTemplateFiles: GfFigmaTemplateFile[];
  isDeleted: boolean;
}

export interface FigmaTemplateFormErrors {
  name?: string;
  numberOfPages?: string;
  category?: string;
  type?: string;
  stores?: string;
  image?: string;
}

export const DEFAULT_FIGMA_TEMPLATE_FORM: FigmaTemplateFormState = {
  name: "",
  numberOfPages: "",
  category: [],
  type: "",
  stores: [],
  figmaTemplateFiles: [],
  isDeleted: false,
};

export const validateFigmaTemplateForm = (
  form: FigmaTemplateFormState,
  t: (k: any) => string,
  messages: any
): FigmaTemplateFormErrors => {
  const errors: FigmaTemplateFormErrors = {};
  if (!form.name.trim())
    errors.name = `${t(messages.Name())} ${t(messages.is_Empty())}`;
  if (form.numberOfPages === "" || form.numberOfPages === undefined)
    errors.numberOfPages = `Number Of Pages ${t(messages.is_Empty())}`;
  if (!form.type)
    errors.type = `${t(messages.Type())} ${t(messages.is_Empty())}`;
  if (
    form.type === CreateGfFigmaTemplateDataDto.TypeEnum.Specific &&
    !form.stores.length
  )
    errors.stores = `${t(messages.Stores())} ${t(messages.is_Empty())}`;
  // Image, category, and figmaTemplateFiles are optional fields
  return errors;
};

export const isFormValid = (errors: FigmaTemplateFormErrors) =>
  Object.keys(errors).length === 0;

export const buildCreateOrUpdatePayload = (
  form: FigmaTemplateFormState
): CreateGfFigmaTemplateDataDto | UpdateGfFigmaTemplateDataDto => {
  const payload = {
    isDeleted: form.isDeleted,
    name: form.name.trim(),
    figmaTemplateTag: form.figmaTemplateTag,
    image: form.image || undefined,
    numberOfPages: Number(form.numberOfPages),
    category: form.category,
    type: form.type as any,
    stores:
      form.type === CreateGfFigmaTemplateDataDto.TypeEnum.Specific
        ? form.stores
        : [],
    figmaTemplateFiles:
      form.figmaTemplateFiles && form.figmaTemplateFiles.length
        ? [form.figmaTemplateFiles[0]]
        : [],
  };

  return payload as any;
};
